import React from "react"
import { navigate } from "gatsby"
import { PageRoute } from "../../../../../../../../types/routes"
import Texts, { TextColor } from "../../../../../../../../../Texts"
import { TextWeight } from "../../../../../../../../../Texts/types/textTypes"

type Props = {
  isFirst: boolean
  isLast: boolean
  isOpen: boolean
  subItem: PageRoute
}

const SubListItem = ({ isFirst, isLast, isOpen, subItem }: Props) => {
  return (
    <li
      className={`py-2 px-3 hover:bg-igem-dark-blue hover:bg-opacity-90 transition-all duration-300
                  ${isFirst ? "rounded-t" : ""} ${isLast ? "rounded-b" : "b"}
                  ${
                    isOpen
                      ? "opacity-100 cursor-pointer"
                      : "opacity-0 cursor-default"
                  }`}
      onClick={() => {
        if (isOpen) {
          navigate(`/${subItem.route}`)
        }
      }}
    >
      <Texts.Button1 color={TextColor.White} weight={TextWeight.Light}>
        {subItem.label}
      </Texts.Button1>
    </li>
  )
}

export default SubListItem
